import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import StandardCoursesSection from 'containers/Overview/Sections/StandardCourses';
import React, { Component } from 'react';

var StandardCourses = /*#__PURE__*/function (_Component) {
  _inherits(StandardCourses, _Component);

  var _super = _createSuper(StandardCourses);

  function StandardCourses() {
    _classCallCheck(this, StandardCourses);

    return _super.apply(this, arguments);
  }

  _createClass(StandardCourses, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: "overview"
      }, /*#__PURE__*/React.createElement("div", {
        className: "section",
        id: "section-courses",
        style: {
          padding: 0,
          margin: 0,
          border: 0
        }
      }, /*#__PURE__*/React.createElement(StandardCoursesSection, null)));
    }
  }]);

  return StandardCourses;
}(Component);

export default StandardCourses;